// Fixtures für die Spam/Phishing-Review-Queue (#310) — ohne Live-Nexus.
export function flaggedFixture(level = 'all') {
  const now = new Date().toISOString();
  const items = [
    {
      id: 5012, tenantId: 't-42', userId: 42,
      from: { address: 'billing@paypa1-secure.com', name: 'PayPal Service' },
      subject: 'Ihr Konto wurde eingeschränkt — jetzt bestätigen',
      phishingLevel: 'high', phishingScore: 0.94, spam: false, spamLevel: null,
      mailbox: 'kunde@example.de', receivedAt: now,
    },
    {
      id: 5008, tenantId: 't-42', userId: 42,
      from: { address: 'news@shop-deals.biz', name: 'Shop Deals' },
      subject: '🔥 -70% nur heute — Newsletter',
      phishingLevel: 'low', phishingScore: 0.2, spam: true, spamLevel: 'high',
      mailbox: 'kunde@example.de', receivedAt: now,
    },
    {
      id: 4999, tenantId: 't-7', userId: 7,
      from: { address: 'team@rechnung-online.net', name: 'Rechnung' },
      subject: 'Offene Rechnung #88213',
      phishingLevel: 'medium', phishingScore: 0.61, spam: false, spamLevel: null,
      mailbox: 'buchhaltung@firma.de', receivedAt: now,
    },
  ];
  const filtered = level === 'all' ? items
    : level === 'spam' ? items.filter((i) => i.spam)
      : items.filter((i) => i.phishingLevel === level);
  return { items: filtered, nextBefore: null };
}
